<div id="se-text-editor-readonly-div" *ngIf="isDisabled" [innerHTML]="readOnlyContentDiv"
     [ngClass]="{ 'se-text-editor-disabled': isInactive }" class="se-text-editor-readonly-div"></div>

<div class="se-text-editor-menu-bar">
    <mat-checkbox *ngIf="visibilityButtonEnabled" class="visibility-button" [checked]="isVisible"
                  [disabled]="isDisabled" (change)="setVisibility(!isVisible)"></mat-checkbox>

    <!--suggestions -->
    <se-text-editor-menu-item (click)="isInactive || !suggestionList || !suggestionList.length ? null : menuManager.onShowSuggestions()"
                              label="{{ 'se-ui-text-editor_cmd_suggestions_tooltip' | translate }} {{ getShortcut('suggestion-open') }}"
                              [matIconName]="'emoji_objects'" *ngIf="!isDisabled && isMenuItemVisible(menuEnum.SUGGESTIONS) && suggestionList?.length"
                              [disabled]="isInactive || !suggestionList || !suggestionList.length">
    </se-text-editor-menu-item>


    <div *ngIf="!lightLayout && !suggestionList.length && !isEditing">
        <se-text-editor-menu-item (click)="menuManager.onEmptySuggestions()"
                                  label="{{ 'se-ui-text-editor_cmd_suggestions_tooltip' | translate }} {{ getShortcut('suggestion-open') }}"
                                  [matIconName]="'emoji_objects'" *ngIf="!isDisabled && isMenuItemVisible(menuEnum.SUGGESTIONS)"
                                  [disabled]="isInactive">
        </se-text-editor-menu-item>
    </div>

    <se-text-editor-menu-item (click)="
            isInactive || !suggestionList || !suggestionList.length || !checkNormalityPresence()
                ? null
                : applyNormality()"
                              label="{{ 'NormalityReport' | translate }} {{getShortcut('apply-normality')}}"
                              [matIconName]="'fact_check'"
                              *ngIf="!isDisabled && isMenuItemVisible(menuEnum.SUGGESTIONS) && suggestionList?.length && checkNormalityPresence()"
                              [disabled]="isInactive || !suggestionList || !suggestionList.length">
    </se-text-editor-menu-item>

    <!-- Extra buttons -->
    <ng-content *ngIf="isVisible" select="[extra-buttons-before]"></ng-content>

    <div *ngIf="title" class="title-container" [class.disabled]="isDisabled">
        <span>{{ title }}</span>
    </div>

    <span *ngIf="!isDisabled && expandSuggestionButton" class="spacer"></span>

    <se-text-editor-menu-item (click)="isInactive ? null : menuManager.onUndo()"
                              label="{{ 'se-ui-text-editor_cmd_undo_tooltip' | translate }}" [matIconName]="'undo'"
                              *ngIf="!isDisabled && isMenuItemVisible(menuEnum.UNDO)" [disabled]="isInactive"
                              [ngClass]="{ 'button-disabled': !editorManager.undoAvailable }">
    </se-text-editor-menu-item>

    <se-text-editor-menu-item (click)="isInactive ? null : menuManager.onRedo()"
                              label="{{ 'se-ui-text-editor_cmd_redo_tooltip' | translate }}" [matIconName]="'redo'"
                              *ngIf="!isDisabled && isMenuItemVisible(menuEnum.REDO)" [disabled]="isInactive"
                              [ngClass]="{ 'button-disabled': !editorManager.redoAvailable }">
    </se-text-editor-menu-item>

    <se-text-editor-menu-item (click)="isInactive ? null : clear()"
                              label="{{ 'se-ui-text-editor_cmd_new_tooltip' | translate }}" [matIconName]="'delete_outline'"
                              *ngIf="!isDisabled && isMenuItemVisible(menuEnum.NEW)" [disabled]="isInactive">
    </se-text-editor-menu-item>

    <!-- font -->
    <se-text-editor-menu-select id="font-family-select" *ngIf="!isDisabled && isMenuItemVisible(menuEnum.TEXT_FONT_FAMILY)" name="font-family-select" maxWidth="100px"
                                [ngModel]="currentContentConfiguration.documentFontFamily" [disabled]="isInactive" [items]="fontFamilyList"
                                [tooltip]="'se-ui-text-editor_cmd_font_family_tooltip' | translate"
                                (ngModelChange)="onFontFamilyChange($event)">
    </se-text-editor-menu-select>

    <se-text-editor-menu-select id="font-family-size" *ngIf="!isDisabled && isMenuItemVisible(menuEnum.TEXT_FONT_SIZE)" name="font-size-select" maxWidth="75px"
                                [ngModel]="currentContentConfiguration.documentFontSize" [disabled]="isInactive"
                                [items]="fontSizeList" [tooltip]="'se-ui-text-editor_cmd_font_size_tooltip' | translate"
                                (ngModelChange)="onFontSizeChange($event)">
    </se-text-editor-menu-select>

    <!-- START font styles: bold, italic, underline  -->
    <se-text-editor-menu-toggle-group [disabled]="isInactive" [multiple]="true"
                                      *ngIf="!isDisabled && isMenuItemVisible(menuEnum.TEXT_FONT_WEIGHT)" [items]="menuFontWeightConfiguration"
                                      [ngModel]="currentContentConfiguration.paragraphFontWeight" (ngModelChange)="onFontWeightChange($event)">
    </se-text-editor-menu-toggle-group>

    <se-text-editor-menu-toggle-group [disabled]="isInactive" [multiple]="true"
                                      *ngIf="!isDisabled && isMenuItemVisible(menuEnum.TEXT_FONT_STYLE)" [items]="menuFontStyleConfiguration"
                                      [ngModel]="currentContentConfiguration.paragraphFontStyle" (ngModelChange)="onFontStyleChange($event)">
    </se-text-editor-menu-toggle-group>

    <se-text-editor-menu-toggle-group [disabled]="isInactive" [multiple]="true"
                                      *ngIf="!isDisabled && isMenuItemVisible(menuEnum.TEXT_DECORATION)" [items]="menuTextDecorationConfiguration"
                                      [ngModel]="currentContentConfiguration.paragraphTextDecoration"
                                      (ngModelChange)="onTextDecorationChange($event)">
    </se-text-editor-menu-toggle-group>

    <!-- END font styles: bold, italic, underline -->
    <!-- align commands -->
    <se-text-editor-menu-toggle-group [disabled]="isInactive" *ngIf="!isDisabled && isMenuItemVisible(menuEnum.TEXT_ALIGNMENT)"
                                      [items]="menuAlignConfiguration" [ngModel]="currentContentConfiguration.paragraphAlign"
                                      name="text_align_toggle_group" (ngModelChange)="onTextAlignChange($event)">
    </se-text-editor-menu-toggle-group>

    <!-- START ordered/unordered list -->
    <se-text-editor-menu-toggle-group [disabled]="isInactive" [multiple]="true"
                                      *ngIf="!isDisabled && isMenuItemVisible(menuEnum.UNORDERED_LIST)" [items]="menuUnOrderedConfiguration"
                                      [(ngModel)]="listConfiguration.unordered" (ngModelChange)="onListClick($event)">
    </se-text-editor-menu-toggle-group>

    <se-text-editor-menu-toggle-group [disabled]="isInactive" [multiple]="true"
                                      *ngIf="!isDisabled && isMenuItemVisible(menuEnum.ORDERED_LIST)" [items]="menuOrderedConfiguration"
                                      [(ngModel)]="listConfiguration.ordered" (ngModelChange)="onListClick($event)">
    </se-text-editor-menu-toggle-group>
    <!-- END ordered/unordered list -->

    <se-text-editor-menu-item (click)="isInactive ? null : openSpeechModal()"
                              label="{{ 'Microphone' | translate}}" [matIconName]="'keyboard_voice'"
                              *ngIf="!isDisabled && isMenuItemVisible(menuEnum.MICROPHONE)" [disabled]="isInactive"
                              style="margin-bottom: 6px">
    </se-text-editor-menu-item>


    <!-- custom commands -->
    <ng-container *ngIf="!isDisabled">
        <se-text-editor-menu-item *ngFor="let customCommand of customCommandConfiguration" label="{{ customCommand.label }}"
                                  (click)="menuManager.onCustomCommand(customCommand.id)" [matIconName]="customCommand.matIconName"
                                  [disabled]="isInactive">
        </se-text-editor-menu-item>
    </ng-container>
</div>
<!-- Attenzione: angular inizializza prosemirror selezionando questo div in base alla sua posizione
  (ultimo figlio). Nel caso vada spostato modificare
la logica di selezione nel file se-text-editor.component.ts -->
<div class="se-text-editor-container" [dir]="this.currentContentConfiguration.documentTextDirection"
     [hidden]="!isVisible" [ngClass]="{ 'se-text-editor-disabled': !isVisible }"></div>
